import { createGlobalStyle } from 'styled-components'

export const GlobalStyleOverride = createGlobalStyle`
  * {
    letter-spacing: -0.2px !important
  }
`
